import { CustomColumnHeader, ID, Lot } from 'types';

export const getNextColumnColumnOrderIndex = (lot: Lot, headerId?: ID): number | undefined => {
  if (!headerId) {
    const existingIndex = lot.custom_column_headers.map(({ column_order_index: order }) => order);

    return Math.max(...existingIndex) + 1;
  }
  const header = lot.custom_column_headers.find(({ id }: CustomColumnHeader) => (
    id === headerId
  ));

  if (!header) return undefined;
  const nextOrder = header.column_order_index + 1;

  return !nextOrder ? undefined : nextOrder;
};
